import { render, staticRenderFns } from "./DownloadPremiereExtension.vue?vue&type=template&id=702e577a&"
import script from "./DownloadPremiereExtension.vue?vue&type=script&lang=js&"
export * from "./DownloadPremiereExtension.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPremiereExtension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports